import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type GetTenantSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantSettingsQuery = { __typename?: 'Query', Tenant: { __typename?: 'TenantQueries', getSettings: { __typename?: 'TenantSettings', isUserDeletionEnabled: boolean, isPatientTransferEnabled: boolean, isCheckInPhotoCaptureEnabled: boolean, callStartSound?: Types.CallStartSound | null, hasOptedInToPrototypeApps: boolean } } };

export type UpsertTenantSettingsMutationVariables = Types.Exact<{
  input: Types.UpsertTenantSettingsInput;
}>;


export type UpsertTenantSettingsMutation = { __typename?: 'Mutation', upsertTenantSettings: boolean };


export const GetTenantSettingsDocument = `
    query GetTenantSettings {
  Tenant {
    getSettings {
      isUserDeletionEnabled
      isPatientTransferEnabled
      isCheckInPhotoCaptureEnabled
      callStartSound
      hasOptedInToPrototypeApps
    }
  }
}
    `;
export const UpsertTenantSettingsDocument = `
    mutation UpsertTenantSettings($input: UpsertTenantSettingsInput!) {
  upsertTenantSettings(input: $input)
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    GetTenantSettings: build.query<GetTenantSettingsQuery, GetTenantSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetTenantSettingsDocument, variables })
    }),
    UpsertTenantSettings: build.mutation<UpsertTenantSettingsMutation, UpsertTenantSettingsMutationVariables>({
      query: (variables) => ({ document: UpsertTenantSettingsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetTenantSettingsQuery, useLazyGetTenantSettingsQuery, useUpsertTenantSettingsMutation } = injectedRtkApi;

